/*
 * premierstreets
 * version 4.5
 * http://www.premierstreets.com
 *
 * Copyright (c) 2021 premier streets
 * Author premier streets <support@premierstreets.com>
 * Licensed under the MIT license.
 */
import { createSelector } from 'reselect';

import * as  fromProduct from './product-control.reducer';
import { AppState } from '../../state.interface';

export const getState = (State: AppState) => State.productControl;
export const getCartList = createSelector(getState, fromProduct.getCartList);
export const getCheckoutCartList = createSelector(getState, fromProduct.getCheckoutCartList);
export const getCartListCount = createSelector(getState, fromProduct.getCartListCount);
export const getTotalCartPrice = createSelector(getState, fromProduct.getTotalCartPrice);
export const getCheckoutCartPrice = createSelector(getState, fromProduct.getCheckoutCartPrice);
export const getCheckedOutData = createSelector(getState, fromProduct.getCheckedOut);



export const addToWishlist = createSelector(getState, fromProduct.addToWishlist);

export const getCheckoutLoading = createSelector(getState, fromProduct.getCheckoutLoading);
export const getCheckoutLoaded = createSelector(getState, fromProduct.getCheckoutLoaded);
export const getCheckoutFailed = createSelector(getState, fromProduct.getCheckoutFailed);

export const getOptionsAvailable = createSelector(getState, fromProduct.getOptionsAvailable);
export const paymentMode = createSelector(getState, fromProduct.getPaymentMode);
export const wishListLoading = createSelector(getState, fromProduct.getWhislistLoading);

export const getCheckProductAvailabilityData = createSelector(getState, fromProduct.getCheckProductAvailability);
export const getCheckProductAvailabilityLoading = createSelector(getState, fromProduct.getCheckProductAvailabilityLoading);
export const getCheckProductAvailabilityLoaded = createSelector(getState, fromProduct.getCheckProductAvailabilityLoaded);
export const getCheckProductAvailabilityFailed = createSelector(getState, fromProduct.getCheckProductAvailabilityFailed);

export const getApplyCoupon = createSelector(getState, fromProduct.getApplyCoupon);
export const getApplyCouponLoading = createSelector(getState, fromProduct.getApplyCouponLoading);
export const getApplyCouponLoaded = createSelector(getState, fromProduct.getApplyCouponLoaded);
export const getApplyCouponFailed = createSelector(getState, fromProduct.getApplyCouponFailed);

export const getRewardPointToUse = createSelector(getState, fromProduct.rewardPointToUse);
export const getRewardPointAmount = createSelector(getState, fromProduct.rewardPointAmount);
export const getLoyaltyDiscountAmount = createSelector(getState, fromProduct.loyaltyDiscountAmount);
export const getLoyaltyAppliedProducts = createSelector(getState, fromProduct.loyaltyAppliedProducts);
export const getAppliedLoyaltyPromotionId = createSelector(getState, fromProduct.appliedLoyaltyPromotionId);

export const getAppliedGiftCardId = createSelector(getState, fromProduct.appliedGiftCardId);
export const getGiftCardDiscountAmount = createSelector(getState, fromProduct.giftCardDiscountAmount);

export const getPromotionalCode = createSelector(getState, fromProduct.promotionalCode);
export const getPromoDiscountAmount = createSelector(getState, fromProduct.promoDiscountAmount);
export const getPromoAppliedProducts = createSelector(getState, fromProduct.promoAppliedProducts);

export const backorderCheckout = createSelector(getState, fromProduct.backorderCheckout);
export const backorderCheckoutLoading = createSelector(getState, fromProduct.backorderCheckoutLoading);
export const backorderCheckoutLoaded = createSelector(getState, fromProduct.backorderCheckoutLoaded);

export const backorder = createSelector(getState, fromProduct.backorder);
export const backorderTotal = createSelector(getState, fromProduct.backorderTotal);
export const backorderProduct = createSelector(getState, fromProduct.backorderProduct);

export const makeQuatation = createSelector(getState, fromProduct.makeQuatation);
export const makeQuatationLoading = createSelector(getState, fromProduct.makeQuatationLoading);
export const makeQuatationLoaded = createSelector(getState, fromProduct.makeQuatationLoaded);
